// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"Blog_thumbnail__6fymb","title":"Blog_title__pI7CE","article_title":"Blog_article_title__5wYfw"};